/* eslint-disable import/prefer-default-export */
import { createStore } from 'redux';
import reducer from './reducers';

export const store = createStore(reducer);
